import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CommonService } from 'src/app/services/common.service';
import { ICellRendererParams } from 'ag-grid-community';

interface ViewDetailCellRendererParams extends ICellRendererParams {
  onViewDetail?: (data: { id: string; details: object }) => void;
}

@Component({
  selector: 'vrm-view-detail-renderer',
  template: `
    <button
      mat-button
      vrm-button
      style="color: white;"
      [style.background-color]="'#' + cService.userProfile?.HqColour"
      (click)="onClick()"
    >
      View Detail
    </button>
  `,
  styles: [
    `
      button {
        position: absolute;
        top: 3px;
        bottom: 3px;
        border: 0px;
        text-align: center;
        font: normal normal medium 11px/20px;
        letter-spacing: -0.28px;
        color: #ffffff;
        text-transform: uppercase;
        opacity: 1;
        border-radius: 5px;
        cursor: pointer;
      }
    `,
  ],
})
export class ViewDetailRendererComponent implements ICellRendererAngularComp {
  private params: ViewDetailCellRendererParams;

  constructor(public cService: CommonService) {}

  agInit(params: ICellRendererParams): void {
    this.params = params as ViewDetailCellRendererParams;
  }

  refresh(): boolean {
    return false;
  }

  onClick(): void {
    if (this.params?.onViewDetail && typeof this.params.onViewDetail === 'function') {
      this.params.onViewDetail(this.params.data);
    }
  }
}
